var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alerte px-5 text-center"},[_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('AgrButton',{staticClass:"ma-5",on:{"click":function($event){return _vm.reload()}}},[_c('v-icon',[_vm._v("mdi-refresh")]),_vm._v(" Réessayer ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }